import { NotifyDialog } from '~/components/notify'
import { Box, Tooltip, styled } from '@material-ui/core'
import { careStore } from '~/companies/care/care.store'
import React from 'react'
import { useTranslation } from '@opus/web.core.hooks.use-translation'

export const TooltipReferDialog = ({ openTooltip, setOpenTooltip }) => {
	const { t } = useTranslation()
	const { getReferalRewardContent } = careStore
	return (
		<NotifyDialog
			open={openTooltip}
			onOk={() => {
				setOpenTooltip(false)
			}}
			title={t('$MESSAGES.REFER_EARN')}
		>
			<Box>
				<div dangerouslySetInnerHTML={{ __html: getReferalRewardContent }}></div>
			</Box>
		</NotifyDialog>
	)
}

export const HomePageTooltip = styled(({ className, ...rest }) => <Tooltip {...rest} classes={{ popper: className, arrow: className }} />)({
	'& .MuiTooltip-tooltip': {
		fontSize: '14px',
		fontWeight: '500',
		lineHeight: '22px',
		background: '#000',
		padding: '8px 12px',
	},

	'& .MuiTooltip-arrow': {
		color: '#000',
	},
})
